import { useLang } from '../i18n'

const color = '#10b981'
const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:3004'

export default function Footer() {
  const { t } = useLang()
  const f = t.footer
  const year = new Date().getFullYear()

  return (
    <footer style={{ background: '#080808', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '60px 24px 32px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 48 }} className="footer-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 30, height: 30, borderRadius: 7, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"/>
                </svg>
              </div>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 17 }}>ubi<span style={{ color }}>gym</span></span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 14, lineHeight: 1.7, margin: '0 0 20px', maxWidth: 260 }}>{f.desc}</p>
            <a href={`mailto:${f.email}`} style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, textDecoration: 'none' }}>{f.email}</a>
          </div>

          <div>
            <h4 style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 18px' }}>{f.product}</h4>
            {[[f.links.howItWorks, '#how']].map(([l, h]) => (
              <a key={l} href={h} style={{ display: 'block', color: 'rgba(255,255,255,0.4)', fontSize: 14, textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'white'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
                {l}
              </a>
            ))}
          </div>

          <div>
            <h4 style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 18px' }}>{f.account}</h4>
            {[[f.links.signIn, `${APP_URL}/login`], [f.links.contact, `mailto:${f.email}`]].map(([l, h]) => (
              <a key={l} href={h} style={{ display: 'block', color: 'rgba(255,255,255,0.4)', fontSize: 14, textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'white'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
                {l}
              </a>
            ))}
          </div>

          <div>
            <h4 style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 18px' }}>{f.legal}</h4>
            {[f.links.privacy, f.links.terms, f.links.cookies].map(l => (
              <a key={l} href="#" style={{ display: 'block', color: 'rgba(255,255,255,0.4)', fontSize: 14, textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'white'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
                {l}
              </a>
            ))}
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: 'rgba(255,255,255,0.2)', fontSize: 13, margin: 0 }}>© {year} UbiGym. {f.rights}</p>
          <p style={{ color: 'rgba(255,255,255,0.15)', fontSize: 12, margin: 0 }}>{f.madeFor}</p>
        </div>
      </div>

      <style>{`
        .footer-grid { grid-template-columns: 2fr 1fr 1fr 1fr; }
        @media (max-width: 768px) { .footer-grid { grid-template-columns: 1fr; gap: 32px; } }
      `}</style>
    </footer>
  )
}
